export const GRAPH_PROVIDER_TYPES: CoreGraphProviderType[] = ['link', 'socket', 'rest'];